// Wrapping the History API here to push analytics when state is pushed
export default {
  supportsHistory: function () {
    return window.history && window.history.pushState;
  },
  pushState: function (data, title, url) {
    if (this.supportsHistory()) {
      window.history.pushState(data, title, url);

      // Trigger Analytics
      if (typeof analytics !== "undefined") {
        analytics.page();
      }
    }
  },
  pushStateNoTracking: function (data, title, url) {
    if (this.supportsHistory()) {
      window.history.pushState(data, title, url);
    }
  },
}
